import React from "react";
import ZButton from "@atoms/ZButton";
import ZModal from "@atoms/ZModal";
import ZIcon from "@atoms/ZIcon";
import { EIcons } from "@atoms/ZIcon/interface";
import { EColors } from "@atoms/ZColors/interface";
import { IUpdateProductCatalogResultColumnProps } from "./interface";
import ZTypography from "@atoms/ZTypography";
import { currencyFormatter } from "@/Utils/Currency";
import { getProductCatalogResultDisplayPrice } from "@/Contracts/Utils";
import { displayPricingName } from "@/Contracts/Products";
import ZTooltip from "@atoms/ZTooltip";
import { EFontWeights } from "@atoms/ZTypography/interface";

const { ZText } = ZTypography;

const ZUpdateProductCatalogResultColumn: React.FC<
	IUpdateProductCatalogResultColumnProps
> = props => {
	const onUpdate = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.stopPropagation();
		props.onUpdateFieldClick();
	};

	const onRemove = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.stopPropagation();
		ZModal.confirm({
			title: "Are you sure you want to remove this item?",
			cancelText: "No",
			okText: "Yes",
			onOk: props.onRemoveItem
		});
	};

	const selectedPricing =
		props.record?.pricing?.find(pricing => {
			return props.selectedPricingId === pricing.id;
		}) ||
		props.record?.pricing[0] ||
		null;

	const pricingDetails = selectedPricing?.distributor_pricing_details;
	const amazonPricingVATlabel =
		selectedPricing?.amazon_business_pricing_details?.tax_exclusive_price
			.label;
	return (
		<div className={`text-center product-pricing-container`}>
			{!props.updated && (
				<>
					{props.showPricing &&
						(props.dellRecord ? (
							<div className="text-right mb-2">
								<ZText
									color={EColors.GRAY}
									colorVariant={8}
									className="product-pricing-name"
								>
									Dell Sales Quote:{" "}
								</ZText>
								<ZText>{`${currencyFormatter(
									props.dellRecord.sell_price,
									"Not available"
								)}`}</ZText>
							</div>
						) : (
							props.record && (
								<div className="flex justify-end text-right mb-2 items-center">
									<ZTooltip
										title={displayPricingName(
											selectedPricing
										)}
									>
										<ZText
											color={EColors.GRAY}
											colorVariant={8}
											weight={EFontWeights.MEDIUM}
											className="block truncate "
										>{`${displayPricingName(
											selectedPricing
										)}:`}</ZText>
									</ZTooltip>
									<ZText
										className="ml-2"
										colorVariant={9}
										weight={EFontWeights.MEDIUM}
									>
										{`${currencyFormatter(
											getProductCatalogResultDisplayPrice(
												selectedPricing,
												props.currentItemSource
											),
											"Not available"
										)}`}
									</ZText>
									{amazonPricingVATlabel && (
										<ZText
											weight={EFontWeights.MEDIUM}
											level={0}
											className="whitespace-nowrap"
										>
											&nbsp;{amazonPricingVATlabel}
										</ZText>
									)}
								</div>
							)
						))}
					<div className="flex flex-col items-end">
						<ZButton
							size="small"
							type="primary"
							ghost
							onClick={onUpdate}
							className="w-min"
						>
							Update Fields
						</ZButton>
						{!!pricingDetails && (
							<ZText
								className="mr-2"
								colorVariant={7}
								level={1}
							>{`Stock Level: ${pricingDetails?.total_availability}/${pricingDetails?.total_on_order}`}</ZText>
						)}
						<ZButton
							size="small"
							type="link"
							onClick={onRemove}
							className="w-min text-gray-7"
						>
							Remove Item
						</ZButton>
					</div>
				</>
			)}
			{props.updated && (
				<ZIcon
					name={EIcons.CHECKCIRCLE}
					color={EColors.GRAY}
					colorVariant={1}
					fill={true}
					fillstrokesame={false}
					fillColor={EColors.GREEN}
					fillColorVariant={6}
				/>
			)}
		</div>
	);
};

export default ZUpdateProductCatalogResultColumn;
